import { lazy, Suspense } from 'react'
import './App.css'

const AnimatedLogo = lazy(() => import('./Misc/AnimatedLogo'))

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Suspense fallback={null}>
          <AnimatedLogo className="App-logo-animated" />
        </Suspense>
      </header>
    </div>
  )
}

export default App
